import * as types from '../actions/ActionTypes';

const INITIAL_STATE = {
  visible: false,
  title: null,
  data: {},
  editData: {},
  registrationTreeBranches: [],
  readyBuildState: false,
  fullTree: []
};

export function wizardReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_VISIBILITY:
      return {
        ...state,
        visible: action.payload.visibility,
        data: action.payload.data.data,
        title: action.payload.data.title,
        editData: action.payload.data.editData
      };

    case types.UPDATE_EDIT_DATA:
      return Object.assign({}, state, {
        editData: action.payload
      });

    case types.SET_RECURSIVE_EDIT_DATA_FULFILLED:
      return { ...state,
        registrationTreeBranches: [...state.registrationTreeBranches, ...action.payload],
        readyBuildState: true
      };
    case types.CREATED_TREE:
      return {
        ...state,
        fullTree: action.payload,
        readyBuildState: false,
        registrationTreeBranches: []
      };
    case types.FAILED_TREE_CREATION:
      return {
        ...state,
        fullTree: [],
        registrationTreeBranches: [],
        readyBuildState: false
      };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/wizard.reducer.js